import { render, staticRenderFns } from "./PublicHeader.vue?vue&type=template&id=0904791a"
import script from "./PublicHeader.vue?vue&type=script&lang=js"
export * from "./PublicHeader.vue?vue&type=script&lang=js"
import style0 from "./PublicHeader.vue?vue&type=style&index=0&id=0904791a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports